tip-presentation-root .reveal h2 {
  font-size: 60px;
  padding-bottom: 10px;
  font-family: "Montserrat";
}

tip-presentation-root .reveal h3 {
  font-size: 50px;
  padding-bottom: 10px;
  font-family: "Montserrat";
}

tip-presentation-root .reveal h5 {
  font-family: "Montserrat";
}

tip-presentation-root .reveal table {
  border: 1px solid black;
}

tip-presentation-root .reveal table.center {
  margin-left:auto;
  margin-right:auto;
}


tip-presentation-root .reveal th {
  border: 1px solid black;
  padding: 10px;
  font-weight: bold;
  font-family: "Montserrat";
}

tip-presentation-root .reveal td {
  border: 1px solid black;
  padding: 10px;
  font-family: "Montserrat";
}

tip-presentation-root .reveal td.changed {
  background-color: rgb(255, 255, 150);
}

tip-presentation-root .reveal img.logo {
  max-width: 50%;
}

tip-presentation-root .reveal td.bold {
  font-weight: bold;
}

tip-presentation-root .reveal p {
  padding: 10px;
  line-height: 130%;
  font-family: "Montserrat";
}
